export var summaryTechnicalSheet = function summaryTechnicalSheet() {
  return {
    content_id: 'principais-informacoes-do-produto',
    content_type: 'produto:informacao-gerada-por-ia',
    event: 'view_content'
  };
};
export default summaryTechnicalSheet;